<template>
  <SmartcatAttachmentComp :used-in="'SmartcatAttachment'"/>
</template>
